import { Application } from "@hotwired/stimulus"
import { setupCSRFProtection } from "../services/csrf_service"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Setup CSRF protection for fetch requests
setupCSRFProtection()

export { application }
